var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"distribution-wrapper"},_vm._l((_vm.distributionsData),function(v,index){return _c('distribution',{key:index,attrs:{"distributionData":v}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }